// AddNote.jsx
import React, { useEffect, useState } from "react";
import { Form, Row, Col, Input, Label, Button, Spinner } from "reactstrap";
import Multiselect from "multiselect-react-dropdown";

/* Use your shared API wrapper from ../import */
import { CreateCustomerList } from "../import/ApiEndPoint/ApiCalling";

function AddNote({ type = "Credit", onSubmit }) {
  const [partyList, setPartyList] = useState([]);
  const [loadingParties, setLoadingParties] = useState(false);
  const [form, setForm] = useState({
    date: "",
    partyId: "",
    totalAmount: "",
    database: "",
  });

  /* Load user & customers */
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userData") || "{}");
    setForm((s) => ({ ...s, database: user?.database || "" }));

    if (!user?._id || !user?.database) return;

    (async () => {
      setLoadingParties(true);
      try {
        const res = await CreateCustomerList(user?._id, user?.database);
        const list = res?.Customer || [];
        // (Optional) normalize any fields if needed
        setPartyList(list);
      } catch (e) {
        setPartyList([]);
      } finally {
        setLoadingParties(false);
      }
    })();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Ensure totalAmount is numeric
    if (name === "totalAmount") {
      setForm((s) => ({ ...s, [name]: value === "" ? "" : Number(value) }));
    } else {
      setForm((s) => ({ ...s, [name]: value }));
    }
  };

  const handleSelectionParty = (_selectedList, selectedItem) => {
    setForm((s) => ({ ...s, partyId: selectedItem?._id || "" }));
  };

  const handleRemoveParty = () => {
    setForm((s) => ({ ...s, partyId: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !form.date ||
      !form.partyId ||
      form.totalAmount === "" ||
      form.totalAmount === null
    ) {
      return alert("Please fill Date, Particular and Amount.");
    }
    onSubmit(e, form);
  };

  return (
    <div style={{ padding: 6 }}>
      <style>{`
        .mini-title { font-weight: 600; font-size: 16px; margin: 4px 0 10px; text-transform: uppercase; text-align:center; }
        .label-sm { font-size: 12px; font-weight: 600; margin-bottom: 6px; }
        .input-sm { height: 32px; font-size: 13px; }
        .btn-compact { height: 30px; padding: 0 14px; font-weight: 600; }
        /* Multiselect sizing */
        .ms-wrapper :where(input, .chip) { font-size: 12px !important; }
        .ms-wrapper .searchBox { min-height: 28px !important; }
        .ms-wrapper .optionContainer { max-height: 220px; }
      `}</style>

      <div className="mini-title">Add {type} Note</div>

      <Form onSubmit={handleSubmit}>
        <Row className="g-2">
          <Col lg="4" md="4" sm="12" className="mb-2">
            <Label className="label-sm">Date *</Label>
            <Input
              required
              type="date"
              name="date"
              value={form.date}
              onChange={handleChange}
              className="input-sm"
            />
          </Col>

          <Col lg="4" md="4" sm="12" className="mb-2">
            <Label className="label-sm">Particular *</Label>
            {loadingParties ? (
              <div
                style={{ display: "flex", alignItems: "center", height: 32 }}
              >
                <Spinner size="sm" color="primary" />
                <span style={{ marginLeft: 8, fontSize: 12 }}>Loading...</span>
              </div>
            ) : (
              <div className="ms-wrapper">
                <Multiselect
                  selectionLimit={1}
                  isObject={true}
                  options={partyList}
                  displayValue="CompanyName"
                  onSelect={handleSelectionParty}
                  onRemove={handleRemoveParty}
                  placeholder="Select party"
                  style={{
                    chips: { minHeight: 28, padding: "2px 6px" },
                    multiselectContainer: { minHeight: 32 },
                    searchBox: {
                      minHeight: 32,
                      padding: "2px 8px",
                      fontSize: 13,
                    },
                  }}
                />
              </div>
            )}
          </Col>

          <Col lg="4" md="4" sm="12" className="mb-2">
            <Label className="label-sm">Amount *</Label>
            <Input
              required
              type="number"
              name="totalAmount"
              placeholder="Enter Amount ..."
              value={form.totalAmount}
              onChange={handleChange}
              min="0"
              step="0.01"
              className="input-sm"
            />
          </Col>
        </Row>

        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 8 }}
        >
          <Button color="primary" type="submit" className="btn-compact">
            Submit
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default AddNote;
